export default {
    lang: {
        name: 'Official minimum age'
    }
}